import { type Configuration, LogLevel } from '@azure/msal-browser';
import { env } from '../env';

export const msalConfig: Configuration = {
  auth: {
    clientId: env.VITE_AZURE_CLIENT_ID,
    authority: env.VITE_AZURE_AUTHORITY,
    redirectUri: `${env.VITE_APP_BASE_URL}/redirect`,
    postLogoutRedirectUri: `${env.VITE_APP_BASE_URL}/auth/login`,
    navigateToLoginRequestUrl: false,
    knownAuthorities: ['auth.truex.health'],
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) {
          console.error(message);
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [`api://${env.VITE_AZURE_API_CLIENT_ID}/access_as_user`],
};
